package com.havn.app.core.localization

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class HavnLanguageRepository(
    initialLanguage: HavnLanguage = HavnLanguage.fromCode(loadStoredHavnLanguageCode())
) {
    private val _language = MutableStateFlow(initialLanguage)
    val language: StateFlow<HavnLanguage> = _language.asStateFlow()

    fun setLanguage(language: HavnLanguage) {
        _language.value = language
        storeHavnLanguageCode(language.code)
    }
}

expect fun loadStoredHavnLanguageCode(): String?

expect fun storeHavnLanguageCode(code: String)
